import React, { Component } from "react";
import {
  mode,
  profile,
  alert,
  float,
  toFixed,
  format_date,
  GET,
  POST,
  PUT,
  loading,
  Status,
  params,
  required,
  DateRangePicker,
  Select,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  XLSX,
  saveAs,
  StatusTnx,
  linkRole,
  writeClipboard,
  StatusIcon,
  StatusReason,
  isExpiredCancel,
  CopyCell,
  maskAccount,
} from "../../components/CustomComponent.js";

import Dropdown from "react-bootstrap/Dropdown";
import { NumericFormat } from "react-number-format";
import "bootstrap/dist/css/bootstrap.min.css";

const countdownInitial = 60;

// every column of the transaction table, in render order. the column manager
// builds its checkbox list straight from this, so adding a column here is
// enough for it to show up in the menu.
const columnDefs = () => [
  { key: "time", label: "Time" },
  { key: "ref_no", label: "RefNo" },
  {
    key: "ref_qr",
    label: params("type") === "deposits" ? "RefQR" : "RefPayout",
  },
  { key: "customer", label: "Customer" },
  { key: "bank", label: "Bank" },
  { key: "amount", label: "Amount" },
  { key: "fee", label: "Fee" },
  { key: "vat", label: "VAT" },
  { key: "amount_net", label: "Amount Net" },
  { key: "process", label: "Process" },
  { key: "status", label: "Status" },
  { key: "actions", label: "Actions" },
];

const columnStorageKey = () => `columns-${params("type") || "deposits"}`;

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const pageSizeStorageKey = () => `page-size-${params("type") || "deposits"}`;

const loadPageSize = () => {
  const saved = Number(localStorage.getItem(pageSizeStorageKey()));
  return PAGE_SIZE_OPTIONS.includes(saved) ? saved : 10;
};

const loadColumns = () => {
  const columns = {};
  columnDefs().forEach((column) => {
    columns[column.key] = true;
  });
  try {
    const saved = JSON.parse(localStorage.getItem(columnStorageKey()) || "{}");
    Object.keys(columns).forEach((key) => {
      if (typeof saved[key] === "boolean") columns[key] = saved[key];
    });
  } catch (e) {}
  return columns;
};

export default class DepositsWithdrawals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // MODAL
      modal_create: false,
      modal_detail: false,

      columns: loadColumns(),
      page: 1,
      page_size: loadPageSize(),
      table_updated_at: "",
      table_auto_refresh: false,
      table_refresh_countdown: countdownInitial,
      inline_help_popup: null,

      // SEARCH
      filter_status: "",
      filter_start_date: format_date(new Date(new Date().setDate(new Date().getDate() - 3)), "yyyy-mm-dd", "en"),
            filter_end_date: format_date(new Date(), "yyyy-mm-dd", "en"),
      filter_data_search: params("ref_no") || "",
      filter_process_type: "",
      filter_currency: "THB",
      filter_broker: "",

      // EXPORT
      export_date: "",

      // LIST
      data: [],
      loaded: false,
      count: 10,
      data_customer: [],
      data_bank: [],

      // DETAIL
      customer_id: "",
      broker_id: "",

      uid: "",
      type: "",
      ref_no: "",
      status: "",
      amount: "",
      created_at: null,
      cost_gateway: "",
      fee: "",
      fee_rate: "",
      fee_type: "",
      vat: "",
      vat_rate: "",
      vat_type: "",
      is_vat: false,
      is_usdt: false,
      is_topup: false,
      is_hq: false,
      gateway: null,
      amount_net: "",
      open_balance: null,
      close_balance: null,
      currency: "",
      transaction_id: null,
      transfer_date: null,
      remark: null,
      status_reason: null,
      broker: null,
      customer: null,

      bank_code: "",
      bank_account_number: "",
      bank_account_name_th: "",
      bank_account_name_en: "",

      hover_index: -1,
    };
  }

  async componentDidMount() {
    loading(false);
    await Promise.all([this.GetMaster(), this.Get(1)]);
  }

  componentWillUnmount() {
    this.StopTableAutoRefresh();
  }

  showInlineHelpPopup = (event, popup) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const popupWidth = 260;
    const left = Math.min(
      Math.max(rect.left - 8, 16),
      window.innerWidth - popupWidth - 16
    );
    const top = Math.max(rect.top - 16, 16);

    this.setState({
      inline_help_popup: {
        ...popup,
        left,
        top,
      },
    });
  };

  hideInlineHelpPopup = () => {
    this.setState({ inline_help_popup: null });
  };

  copyInlineHelpText = async (text) => {
    if (!(await writeClipboard(text))) return;
    this.setState((prevState) =>
      prevState.inline_help_popup
        ? {
            inline_help_popup: {
              ...prevState.inline_help_popup,
              copied: true,
            },
          }
        : null
    );
  };

  setPageSize = (page_size) => {
    localStorage.setItem(pageSizeStorageKey(), String(page_size));
    // page 1 again: the row the user was looking at lands somewhere else once
    // the page size changes, so keeping the page number would be misleading
    this.setState({ page_size }, () => {
      this.Get(1);
    });
  };

  isColumn = (key) => this.state.columns?.[key] !== false;

  toggleColumn = (key) => {
    this.setState((prevState) => {
      const columns = { ...prevState.columns, [key]: !prevState.columns[key] };
      localStorage.setItem(columnStorageKey(), JSON.stringify(columns));
      return { columns };
    });
  };

  toggleAllColumns = (checked) => {
    const columns = {};
    columnDefs().forEach((column) => {
      columns[column.key] = checked;
    });
    localStorage.setItem(columnStorageKey(), JSON.stringify(columns));
    this.setState({ columns });
  };

  resetColumns = () => {
    localStorage.removeItem(columnStorageKey());
    this.setState({ columns: loadColumns() });
  };

  StartTableAutoRefresh = () => {
    if (this.tableRefreshInterval) return;

    this.setState({
      table_auto_refresh: true,
      table_refresh_countdown: countdownInitial,
    });

    this.tableRefreshInterval = setInterval(async () => {
      const { table_auto_refresh, table_refresh_countdown, page } = this.state;

      if (!table_auto_refresh) return;

      if (table_refresh_countdown <= 1) {
        // silent + current page: refreshing must not flash the full-screen loader
        await this.Get(page, { silent: true });
        this.setState({ table_refresh_countdown: countdownInitial });
        return;
      }

      this.setState({
        table_refresh_countdown: table_refresh_countdown - 1,
      });
    }, 1000);
  };

  StopTableAutoRefresh = () => {
    if (this.tableRefreshInterval) {
      clearInterval(this.tableRefreshInterval);
      this.tableRefreshInterval = null;
    }

    this.setState({
      table_auto_refresh: false,
      table_refresh_countdown: countdownInitial,
    });
  };

  ToggleTableAutoRefresh = () => {
    if (this.state.table_auto_refresh) {
      this.StopTableAutoRefresh();
      return;
    }

    this.StartTableAutoRefresh();
  };
  // ตัวเลือกของ dropdown ทั้งหน้า ไม่เปลี่ยนระหว่างอยู่บนหน้านี้ ดึงครั้งเดียวตอนเปิดหน้า
  // ไม่ยุ่งกับ loading เพราะ Get เป็นคนคุมสถานะโหลดของตาราง
  GetMaster = async () => {
    let data_bank;
    let [result_bank] = await Promise.all([
      GET("v1/admin/banks", { page_size: 100000, page: 0, data_search: "" }),
    ]);
    if (result_bank?.status) {
      const popularBankCodes = [
        "SCB",
        "KBANK",
        "KTB",
        "BBL",
        "BAY",
        "TTB",
        "CIMB",
      ];
      data_bank = result_bank.data
        .sort((a, b) => {
          const indexA = popularBankCodes.indexOf(a.code);
          const indexB = popularBankCodes.indexOf(b.code);

          if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB; // ถ้าอยู่ทั้งคู่ใน popular → เรียงตามลำดับ
          } else if (indexA !== -1) {
            return -1; // a อยู่ใน popular → ให้มาก่อน
          } else if (indexB !== -1) {
            return 1; // b อยู่ใน popular → ให้มาก่อน
          } else {
            return a.name_en.localeCompare(b.name_en); // ไม่อยู่ใน popular → เรียงตามชื่อ
          }
        })
        .map((e) => ({
          value: e.code,
          label: e.name_en,
          front: (
            <img
              alt="bank"
              src={require(`../../assets/images/bank/${
                global.bank.find((b) => b.value === e.code)?.icon || "bank.png"
              }`)}
              width={18}
              height={18}
              style={{ marginRight: 6 }}
            />
          ),
        }));
    }
    this.setState({ data_bank });
  };
  Get = async (page, options = {}) => {
    const { silent = false } = options;
    const {
      filter_data_search,
      filter_start_date,
      filter_end_date,
      filter_status,
      filter_process_type,
      filter_currency,
      filter_broker,
    } = this.state;
    let data, count, data_customer;
    if (!silent) {
      loading(true);
    }
    let [result] = await Promise.all([
      GET(`transactions/${params("type")}/list`, {
        page_size: this.state.page_size,
        page: page,
        data_search: filter_data_search,
        start_date: filter_start_date
          ? format_date(filter_start_date, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_end_date
          ? format_date(filter_end_date, "yyyy-mm-dd", "en")
          : "",
        filter_status: filter_status,
        process_type: filter_process_type,
        currency: filter_currency,
        broker_id: filter_broker,
        is_hq: false,
      }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    this.setState({
      data,
      loaded: true,
      count,
      data_customer,
      page: page || 1,
      table_updated_at: format_date(new Date(), "hh:mm:ss", "en"),
    });
    if (!silent) {
      loading(false);
    }
  };
  GetCustomer = async () => {
      const { currency } = this.state;
      let data_customer;
      let [result_customer] = await Promise.all([
        GET("v1/admin/customers", {
          page_size: 100000,
          page: 0,
          data_search: "",
          currency: currency,
        }),
      ]);
      if (result_customer?.status) {
        data_customer = result_customer?.data.map((e) => ({
          value: e.uid,
          label: e.name_en,
          bank_code: e.bank_code,
          bank_account_name_th: e.bank_account_name_th,
          bank_account_name_en: e.bank_account_name_en,
          bank_account_number: e.bank_account_number,
          broker: e.broker?.uid || "",
          currency: e.currency || "THB",
        }));
      }
      this.setState({
        data_customer,
      });
    };
  Create = async () => {
    const {
      broker_id,
      customer_id,
      ref_no,
      amount,
      bank_code,
      bank_account_number,
      bank_account_name_th,
      bank_account_name_en,
      currency,
      is_topup,
    } = this.state;
    if (!broker_id.trim()) {
      alert("", "warning", "Warning", "Please select Broker");
      return;
    } else if (!ref_no.trim()) {
      alert("", "warning", "Warning", "Please input Ref No");
      return;
    } else if (!amount.trim()) {
      alert("", "warning", "Warning", "Please input Amount");
      return;
    }
    if (!customer_id) {
      alert("", "warning", "Warning", "Please select customer");
      return;
    }

    let body = {
      broker_id,
      customer_id,
      bank_code,
      bank_account_number,
      bank_account_name_th,
      bank_account_name_en,
      ref_no,
      amount: Number(amount),
      currency: currency || "THB",
      is_topup: is_topup || false,
      is_hq: false,
    };
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      let result = await POST(`transactions/${params("type")}/create`, body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };
  Update = async () => {
    const { fee_type, fee_rate, is_vat, status, is_usdt } = this.state;
    if (!fee_type.trim()) {
      alert("", "warning", "Warning", "Please select Fee Rate Type");
      return;
    } else if (!fee_rate.trim()) {
      alert("", "warning", "Warning", "Please input Fee Rate");
      return;
    }
    if (["cancel", "success"].includes(status)) {
      Swal.fire({
        title: "Confirm",
        text: `Do you want to ${
          status === "cancel" ? "Reject" : "Approve"
        } the transaction?`,
        icon: "info",
        input: "textarea",
        inputPlaceholder: "Enter remark...",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        background: mode === "dark" ? "#000000" : "#fff", // Dark / Light background
        color: mode === "dark" ? "#fff" : "#000000", // Text color
        confirmButtonColor: mode === "dark" ? "#e29f04" : "#212529",
        cancelButtonColor: mode === "dark" ? "#aaa" : "unset",
      }).then(async (re) => {
        if (re.isConfirmed) {
          const remark = re.value;
          loading(true);
          let body = {
            fee_type,
            fee_rate: Number(fee_rate).toFixed(4),
            is_vat,
            status,
            is_usdt,
            remark,
          };

          let result = await PUT(
            `transactions/${params("type")}/update/` + this.state.uid,
            body
          );
          if (result?.status) {
            alert("#", "success");
          } else {
            alert(
              "",
              "warning",
              "Warning",
              result?.message || "An error occurred. Please try again."
            );
          }
          loading(false);
        }
      });
    } else {
      if (
        await alert(
          "",
          "info",
          "Confirm",
          "Do you want to confirm the submission?",
          "Confirm",
          "Cancel"
        )
      ) {
        loading(true);
        let body = {
          fee_type,
          fee_rate: Number(fee_rate).toFixed(4),
          is_vat,
          status,
          is_usdt,
        };

        let result = await PUT(
          `transactions/${params("type")}/update/` + this.state.uid,
          body
        );
        if (result?.status) {
          alert("#", "success");
        } else {
          alert(
            "",
            "warning",
            "Warning",
            result?.message || "An error occurred. Please try again."
          );
        }
        loading(false);
      }
    }
  };
  calDetail = async () => {
    const { fee_type, fee_rate, is_vat, amount, cost_gateway } = this.state;
    const _amount = Number(amount);
    const _fee =
      fee_type === "fixed"
        ? Number(fee_rate)
        : Number((_amount * (Number(fee_rate) / 100)).toFixed(4));
    const _vat = Number((_fee * 0.07).toFixed(4));
    const amountAfterFee = _amount - _fee;
    let amountNet = is_vat
      ? Number((amountAfterFee - _vat - Number(cost_gateway)).toFixed(4))
      : Number(amountAfterFee.toFixed(4));

    this.setState({
      fee: _fee.toFixed(4),
      amount_net: amountNet.toFixed(4),
      vat: is_vat ? _vat.toFixed(4) : "00.00",
    });
  };
  ExportCSV = async () => {
      const {
        filter_data_search,
        filter_start_date,
        filter_end_date,
        filter_status,
        filter_process_type,
        filter_broker,
      } = this.state;
      loading(true);
      let result = await GET(`transactions/${params("type")}/list`, {
        page_size: 100000,
        page: 0,
        data_search: filter_data_search,
        start_date: filter_start_date
          ? format_date(filter_start_date, "yyyy-mm-dd", "en")
          : format_date(new Date(), "yyyy-mm-01", "en"),
        end_date: filter_end_date
          ? format_date(filter_end_date, "yyyy-mm-dd", "en")
          : format_date(
              new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
              "yyyy-mm-dd",
              "en",
            ),
        filter_status: filter_status || "success",
        process_type: filter_process_type,
        currency: "",
        broker_id: filter_broker,
        is_hq: false,
      });
      if (result?.status) {
        const data_transaction = result.data;
  
        // EXPORT CSV
        const json_data = data_transaction.map((item) => ({
          time: format_date(item.created_at, "dd/mm/yy hh:mm", "en"),
          "Ref No": item.ref_no,
          RefQR: item.reference_id,
          Broker: item.broker?.name_en || "-",
          Customer: item.customer?.name_en || "-",
          Amount: toFixed(item.amount, 2),
          Fee: toFixed(item.fee, 2),
          "VAT Type": item.is_vat ? "VAT" : "NO VAT",
          VAT: item.is_vat ? toFixed(item.vat, 2) : "-",
          "Amount Net": toFixed(item.amount_net, 2),
          Process:
            item.process_type === "manual"
              ? "Manual"
              : item.process_type === "auto"
                ? "Auto"
                : "-",
          Status: item.ref_no_refund ? "refund" : (item.status || "-"),
          Remark: item.remark,
          currency: item.currency,
        }));
        // 1. Convert JSON to worksheet
        const worksheet_thb = XLSX.utils.json_to_sheet(
          json_data.filter((e) => e.currency === "THB"),
        );
        const worksheet_lak = XLSX.utils.json_to_sheet(
          json_data.filter((e) => e.currency === "LAK"),
        );
  
        // 2. Create a new workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet_thb, "THB");
        XLSX.utils.book_append_sheet(workbook, worksheet_lak, "LAK");
  
        // 3. Write the workbook to binary buffer
        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
  
        // 4. Save to file
        const data = new Blob([excelBuffer], {
          type: "application/octet-stream",
        });
        saveAs(
          data,
          `${params("type")}-${format_date(
            filter_start_date,
            "dd/mm/yy",
            "en",
          )}-${format_date(filter_end_date, "dd/mm/yy", "en")}.xlsx`,
        );
      }
      loading(false);
    };

  ReWithdrawal = async () => {
    const { uid } = this.state;
    Swal.fire({
      title: "Confirm",
      text: `Do you want to "withdrawal" again?`,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      background: mode === "dark" ? "#000000" : "#fff", // Dark / Light background
      color: mode === "dark" ? "#fff" : "#000000", // Text color
      confirmButtonColor: mode === "dark" ? "#e29f04" : "#212529",
      cancelButtonColor: mode === "dark" ? "#aaa" : "unset",
    }).then(async (re) => {
      if (re.isConfirmed) {
        loading(true);
        let body = { uid };
        let result = await POST(`transactions/withdrawals`, body);
        if (result?.status) {
          alert("#", "success");
        } else {
          alert(
            "",
            "warning",
            "Warning",
            result?.message || "An error occurred. Please try again."
          );
        }
        loading(false);
      }
    });
  };

  Callback = async () => {
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the Callback?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      const { uid } = this.state;
      let body = { uid };
      let result = await POST(`callback/re-callback`, body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };
  render() {
    const {
      modal_create,
      modal_detail,
      filter_status,
      filter_start_date,
      filter_end_date,
      filter_data_search,
      filter_process_type,
      filter_currency,
      data,
      loaded,
      count,
      data_customer,
      data_bank,
      broker_id,
      customer_id,
      uid,
      type,
      ref_no,
      status,
      amount,
      created_at,
      fee,
      fee_rate,
      fee_type,
      vat,
      is_vat,
      is_topup,
      amount_net,
      currency,
      remark,
      status_reason,
      broker,
      customer,
      bank_code,
      bank_account_number,
      bank_account_name_th,
      bank_account_name_en,
      is_usdt,

      hover_index,
      page,
      page_size,
      table_updated_at,
      table_auto_refresh,
      table_refresh_countdown,
      inline_help_popup,
    } = this.state;
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          {inline_help_popup && (
            <div
              className="inline-help-popup"
              style={{
                left: inline_help_popup.left,
                top: inline_help_popup.top,
              }}
            >
              <div
                className="fw-semibold mb-1"
                style={{
                  fontSize: 12,
                  color: inline_help_popup.titleColor || "#344054",
                }}
              >
                {inline_help_popup.title}
              </div>
              {inline_help_popup.lines?.map((line, idx) => (
                <div key={`inline-help-${idx}`} className="text-14">
                  {line}
                </div>
              ))}
              {inline_help_popup.copyable && (
                <div
                  className="fw-semibold mt-1"
                  style={{
                    fontSize: 11,
                    color: inline_help_popup.copied ? "#079455" : "#98a2b3",
                  }}
                >
                  {inline_help_popup.copied ? "Copied!" : "Click to copy"}
                </div>
              )}
            </div>
          )}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Broker</div>
                <h2 className="ar-title mb-1">
                  {params("type")?.charAt(0).toUpperCase() + params("type")?.slice(1)}{" "}
                  Management
                </h2>
                <div className="ar-subtitle">
                  Manage and monitor{" "}
                  {params("type")?.charAt(0).toUpperCase() +
                    params("type")?.slice(1).toLocaleLowerCase()}{" "}
                  transactions
                </div>
              </div>
              <div className="ar-hero-actions">
                <button
                  className={`ar-btn-ghost ${params("type")}.read`}
                  onClick={async () => {
                    this.ExportCSV();
                  }}
                >
                  <span className="icon me-2">{"\uf019"}</span>Export CSV
                </button>
              {/* {profile?.user_type !== "sub_broker" && (
              <button
                className={`btn btn-dark px-3 ms-auto mb-2 ${params(
                  "type"
                )}.create`}
                onClick={async () => {
                  this.setState({
                    id: "",
                    currency: "THB",
                    broker_id:
                      profile?.user_type === "broker"
                        ? profile?.broker?.uid
                        : "",
                    customer_id: "",
                    ref_no: "",
                    amount: "",
                    is_topup: false,
                    is_hq: false,
                    modal_create: true,
                  },()=>{this.GetCustomer()});
                }}
              >
                Create{" "}
                {params("type")?.charAt(0).toUpperCase() +
                  params("type")?.slice(1)}
              </button>
              )} */}
              </div>
            </div>
            <div className="ar-toolbar ar-filter mt-3">
              <div className="ar-filter-head">
                <span className="ar-toolbar-label"><span className="icon me-2">{"\uf0b0"}</span>Filter</span>
                <span className="ar-toolbar-hint">Press Enter in the search box or click Search to apply</span>
              </div>
              <div className="ar-filter-row">
                <div className="ar-filter-field ar-filter-field-search">
                  <span className="ar-filter-label">Search</span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Refno..."
                  onChange={(e) => {
                    this.setState({ filter_data_search: e.target.value });
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      this.Get(1);
                    }
                  }}
                  value={filter_data_search}
                />
                </div>
                <div className="ar-filter-field">
                  <span className="ar-filter-label">Status</span>
                  <Select
                    className="form-control"
                    placeholder="Status"
                    options={[
                      { value: "pending", label: "Pending" },
                      { value: "success", label: "Success" },
                      { value: "mismatch", label: "MisMatch" },
                      { value: "pending-refund", label: "Pending Refund" },
                      { value: "refund", label: "Refund" },
                      { value: "cancel", label: "Cancel" },
                    ]}
                    value={filter_status}
                    onChange={(v) => {
                      this.setState({ filter_status: v });
                    }}
                    default={false}
                  />
                </div>
                <div className="ar-filter-field">
                  <span className="ar-filter-label">Date Range</span>
                  <DateRangePicker
                    className="form-control"
                    onChange={(e) => {
                      this.setState({
                        filter_start_date: e.start_date,
                        filter_end_date: e.end_date,
                      });
                    }}
                    value={{
                      start_date: filter_start_date,
                      end_date: filter_end_date,
                    }}
                    max={filter_end_date}
                  />
                </div>
                <div className="ar-toolbar-actions">
                <button
                  className="ar-btn-gold"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  <span className="icon me-2">{"\uf002"}</span>Search
                </button>
                <button
                  className="ar-btn-ghost"
                  onClick={() =>
                    this.setState(
                      {
                        filter_status: "",
                        filter_start_date: format_date(
                          new Date(new Date().setDate(new Date().getDate() - 3)),
                          "yyyy-mm-dd",
                          "en"
                        ),
                        filter_end_date: format_date(new Date(), "yyyy-mm-dd", "en"),
                        filter_data_search: params("ref_no") || "",
                        filter_process_type: "",
                        filter_currency: "THB",
                        filter_broker: "",
                      },
                      () => this.Get(1)
                    )
                  }
                >
                  Reset
                </button>
                </div>
              </div>
              <div className="ar-filter-foot">
                  {global.currency?.map((item) => (
                    <button
                      className={`ar-pill ${
                        item.currency_code === filter_currency ? "active" : ""
                      }`}
                      onClick={() => {
                        this.setState({ filter_currency: item.currency_code });
                        setTimeout(() => {
                          this.Get(1);
                        }, 100);
                      }}
                    >
                      {item.image}
                      <span className="ms-1">{item.currency_code}</span>
                    </button>
                  ))}
              </div>
            </div>
          </div>
          <div className="ar-table-card">
            <div className="ar-table-head flex-wrap gap-2">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{"\uf0d6"}</span>
                  {params("type")?.charAt(0).toUpperCase() + params("type")?.slice(1)}
                  <span className="pu-currency-tag">{filter_currency}</span>
                </div>
                <div className="ar-table-caption">
                  {count > 0
                    ? `Showing ${(page - 1) * page_size + 1}\u2013${Math.min(
                        page * page_size,
                        count
                      )} of ${count}`
                    : "No results"}
                  {table_updated_at ? (
                    <span className="ms-2">&middot; Updated {table_updated_at}</span>
                  ) : null}
                </div>
              </div>
              <div className="d-flex align-items-center flex-wrap gap-2">
                <button
                  type="button"
                  className="pu-om-ctl pu-ctl-plain"
                  onClick={() => {
                    this.Get(page, { silent: true });
                  }}
                >
                  <span className="icon me-1">{"\uf021"}</span>Refresh
                </button>
                <button
                  type="button"
                  className={`pu-om-ctl pu-ctl-plain ${table_auto_refresh ? "active" : ""}`}
                  onClick={() => {
                    this.ToggleTableAutoRefresh();
                  }}
                >
                  <span className="icon me-1">{"\uf017"}</span>
                  {table_auto_refresh
                    ? `Auto ${table_refresh_countdown}s`
                    : "Auto"}
                </button>
                <Select
                  className="form-control pu-om-rows pu-rows-plain"
                  placeholder="Rows"
                  options={PAGE_SIZE_OPTIONS.map((size) => ({
                    value: size,
                    label: `${size} rows`,
                  }))}
                  value={page_size}
                  onChange={(v) => {
                    this.setPageSize(Number(v));
                  }}
                />
                <Dropdown autoClose="outside" align="end">
                  <Dropdown.Toggle className="pu-om-ctl pu-ctl-plain" id="dw-columns">
                    <span className="icon me-1">{"\uf0db"}</span>Columns
                    <span className="pu-om-ctl-count">
                      {columnDefs().filter((column) => this.isColumn(column.key)).length}
                      /{columnDefs().length}
                    </span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="pu-action-menu" style={{ minWidth: 190, maxHeight: 340, overflowY: "auto" }}>
                    <label className="pu-om-col fw-bold">
                      <input
                        type="checkbox"
                        className="form-check-input m-0 me-2"
                        checked={columnDefs().every((column) =>
                          this.isColumn(column.key)
                        )}
                        onChange={(e) => {
                          this.toggleAllColumns(e.target.checked);
                        }}
                      />
                      All columns
                    </label>
                    <div className="pu-action-sep" />
                    {columnDefs().map((column) => (
                      <label key={`column-${column.key}`} className="pu-om-col">
                        <input
                          type="checkbox"
                          className="form-check-input m-0 me-2"
                          checked={this.isColumn(column.key)}
                          onChange={() => {
                            this.toggleColumn(column.key);
                          }}
                        />
                        {column.label}
                      </label>
                    ))}
                    <div className="pu-action-sep" />
                    <button
                      type="button"
                      className="pu-om-col pu-om-col-reset"
                      onClick={() => {
                        this.resetColumns();
                      }}
                    >
                      Reset to default
                    </button>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            <div className="table-responsive" style={{ minHeight: 300 }}>
              <table className="table table-hover text-nowrap ar-table pu-table pu-table-compact">
                <thead>
                  <tr>
                    {this.isColumn("time") && (
                      <td className="text-nowrap">Time</td>
                    )}
                    {this.isColumn("ref_no") && (
                      <td className="text-nowrap">RefNo</td>
                    )}
                    {this.isColumn("ref_qr") && (
                      <td className="text-nowrap">
                        {params("type") === "deposits" ? "RefQR" : "RefPayout"}
                      </td>
                    )}
                    {this.isColumn("customer") && (
                      <td className="text-nowrap">Customer</td>
                    )}
                    {this.isColumn("bank") && (
                      <td className="text-nowrap">Bank</td>
                    )}
                    {this.isColumn("amount") && (
                      <td className="text-nowrap text-end">Amount</td>
                    )}
                    {this.isColumn("fee") && (
                      <td className="text-nowrap text-end d-none d-md-table-cell">
                        Fee
                      </td>
                    )}
                    {this.isColumn("vat") && (
                      <td className="text-nowrap text-end d-none d-md-table-cell">
                        VAT
                      </td>
                    )}
                    {this.isColumn("amount_net") && (
                      <td className="text-nowrap text-end d-none d-md-table-cell">
                        Amount Net
                      </td>
                    )}
                    {this.isColumn("process") && (
                      <td className="text-nowrap text-center d-none d-md-table-cell">
                        Process
                      </td>
                    )}
                    {this.isColumn("status") && (
                      <td className="text-nowrap text-center wpx-100">Status</td>
                    )}
                    {this.isColumn("actions") && (
                      <td
                        className={`${params("type")}.update text-nowrap text-center td-actions`}
                      >
                        Actions
                      </td>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {loaded && data?.length === 0 && (
                    <tr>
                      <td
                        colSpan={
                          columnDefs().filter((column) =>
                            this.isColumn(column.key)
                          ).length || 1
                        }
                        className="text-center py-5"
                      >
                        <div className="ar-empty">No data</div>
                      </td>
                    </tr>
                  )}
                  {data?.map((item, index) => (
                    <tr key={`array-${index}`}>
                      {this.isColumn("time") && (
                        <td data-label="Time" className="text-nowrap">
                          {format_date(item.created_at, "dd/mm/yy hh:mm:ss", "en")}
                        </td>
                      )}
                      {this.isColumn("ref_no") && (
                        <td data-label="RefNo" className="text-nowrap py-1">
                          <div>
                            {/* the fixed height only makes room for the refund line
                                below, so without it let the value center itself */}
                            <div
                              style={
                                item.ref_no_refund ? { height: 14 } : undefined
                              }
                            >
                              <CopyCell value={item.ref_no} />
                            </div>
                            {item.ref_no_refund && (
                              <div>
                                <small className="text-secondary">
                                  refund no: {item.ref_no_refund}
                                  <span
                                    className="icon ms-1 text-primary pointer"
                                    onClick={() => {
                                      window.location.href = `/${linkRole(profile?.user_type)}/deposits-withdrawals?type=${
                                        params("type") === "deposits"
                                          ? "withdrawals"
                                          : "deposits"
                                      }&ref_no=${item.ref_no_refund}`;
                                    }}
                                  >
                                    {"\uf0c1"}
                                  </span>
                                </small>
                              </div>
                            )}
                          </div>
                        </td>
                      )}
                      {this.isColumn("ref_qr") && (
                        <td data-label="RefQR" className="text-nowrap py-1">
                          <CopyCell
                            value={item.qrs?.reference_id || item.reference_id}
                          />
                        </td>
                      )}
                      {this.isColumn("customer") && (
                        <td data-label="Customer" className="text-nowrap">
                          {item.customer?.name_en || "-"}
                        </td>
                      )}
                      {this.isColumn("bank") && (
                        <td data-label="Bank" className="text-nowrap py-1">
                          {item.bank_code &&
                          global.bank.find((e) => e.value === item.bank_code) ? (
                            <div className="d-flex">
                              <img
                                alt="bank"
                                src={require(`../../assets/images/bank/${
                                  global.bank.find(
                                    (b) => b.value === item.bank_code
                                  )?.icon || "bank.png"
                                }`)}
                                width={18}
                                height={18}
                                style={{ marginRight: 6 }}
                                className="me-2 mt-1"
                              />
                              <div>
                                <div style={{ height: 14 }}>{item.bank_code}</div>
                                <small className="text-secondary">
                                  {maskAccount(item.bank_account_number) || "-"}
                                </small>
                              </div>
                            </div>
                          ) : (
                            "-"
                          )}
                        </td>
                      )}
                      {this.isColumn("amount") && (
                        <td
                          data-label="Amount"
                          className="text-nowrap text-end"
                        >
                          <div className="pu-amount">{toFixed(item.amount, 2)}</div>
                        </td>
                      )}
                      {this.isColumn("fee") && (
                        <td
                          data-label="Fee"
                          className="text-nowrap text-end d-none d-md-table-cell"
                        >
                          {toFixed(item.fee, 2)}
                        </td>
                      )}
                      {this.isColumn("vat") && (
                        <td
                          data-label="VAT"
                          className="text-nowrap text-end d-none d-md-table-cell"
                        >
                          {item.is_vat ? toFixed(item.vat, 2) : "0.00"}
                        </td>
                      )}
                      {this.isColumn("amount_net") && (
                        <td
                          data-label="Amount Net"
                          className="text-nowrap text-end d-none d-md-table-cell"
                        >
                          <div className="pu-amount pu-amount-gold">{toFixed(item.amount_net, 2)}</div>
                        </td>
                      )}
                      {this.isColumn("process") && (
                        <td
                          data-label="Process"
                          className="text-nowrap text-center py-1 d-none d-md-table-cell"
                        >
                          {!item.is_topup && !item.is_hq && (
                            <div className="d-flex align-items-center justify-content-center">
                              {item.process_type === "manual"
                                ? Status("manual", "orange")
                                : item.process_type === "auto"
                                ? Status("auto", "primary")
                                : Status("-", "secondary")}
                            </div>
                          )}
                          {item.is_topup && (
                            <div className="d-flex align-items-center justify-content-center mt-1">
                              {Status("topup", "info")}
                            </div>
                          )}
                          {item.is_hq && (
                            <div className="d-flex align-items-center justify-content-center mt-1">
                              {Status("HQ", "purple")}
                            </div>
                          )}
                        </td>
                      )}
                      {this.isColumn("status") && (
                        <td
                          data-label="Status"
                          className="text-nowrap text-center py-1"
                        >
                          <div className="d-flex align-items-center justify-content-center">
                            {item.ref_no_refund && item.status === "success"
                              ? Status("refund", "info")
                              : isExpiredCancel(item.status, item.status_reason)
                              ? // expired is a timeout, not a rejection: keep it
                                // neutral so red stays reserved for real failures
                                Status("cancel", "secondary")
                              : StatusTnx(item.status)}
                            {["cancel", "success"].includes(item.status) &&
                            !(item.ref_no_refund && item.status === "success") ? (
                              <div
                                className={`ms-1 inline-help-trigger ${
                                  hover_index === index ? "is-active" : ""
                                }`}
                                style={{
                                  background: "transparent",
                                  width: 16,
                                  height: 16,
                                  color: StatusReason(
                                    item.status,
                                    item.status_reason
                                  ).color,
                                }}
                                onMouseEnter={(event) => {
                                  this.setState({ hover_index: index });
                                  this.showInlineHelpPopup(event, {
                                    title: StatusReason(
                                      item.status,
                                      item.status_reason
                                    ).title,
                                    titleColor: StatusReason(
                                      item.status,
                                      item.status_reason
                                    ).color,
                                    lines: [item.status_reason || "-"],
                                    copyable: true,
                                  });
                                }}
                                onMouseLeave={() => {
                                  this.setState({ hover_index: -1 });
                                  this.hideInlineHelpPopup();
                                }}
                                onClick={(event) => {
                                  event.stopPropagation();
                                  this.copyInlineHelpText(item.status_reason);
                                }}
                              >
                                {StatusIcon(
                                  StatusReason(item.status, item.status_reason)
                                    .icon
                                )}
                              </div>
                            ) : null}
                          </div>
                        </td>
                      )}
                      {this.isColumn("actions") && (
                        <td
                          data-label="Actions"
                          className={`text-center ${params("type")}.update td-actions`}
                        >
                          <div className="d-flex justify-content-center">
                            <Dropdown align="end">
                              <Dropdown.Toggle className="pu-action-toggle" id={`dw-actions-${index}`}>Action</Dropdown.Toggle>
                              <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                                <Dropdown.Item className="pu-action-item" onClick={() => { this.setState({ ...item, modal_detail: true}); }}>
                                  <div className="icon">{"\uf06e"}</div> Detail
                                </Dropdown.Item> 
                                {["success", "mismatch", "cancel", "refund"].includes(item.status) && (
                                  <Dropdown.Item className={`${params("type")}.update pu-action-item`} onClick={() => { this.setState({ ...item, broker_id: item?.broker?.uid || "" },() => {this.Callback();}); }}>
                                    <div className="icon">{"\uf1d8"}</div> Resend Callback
                                  </Dropdown.Item>
                                )}
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-3">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / page_size) || 1}
              page={page}
              showFirstButton
              showLastButton
              onChange={(_, value) => this.Get(value)}
            />
          </div>
        </div>
        {/* CREATE UPDATE */}
        <Modal
          show={modal_create}
          dialogClassName="pr-modal pr-scope pu-scope"
          onHide={() => this.setState({ modal_create: false })}
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">New transaction</div>
              <h5 className="fw-bold mb-0">
                Create Transaction{" "}
                {params("type")?.charAt(0).toUpperCase() +
                  params("type")?.slice(1)}
              </h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2 pr-label">Currency</div>
              <Select
                className="form-control pr-input"
                placeholder="Currency..."
                options={global.currency?.map((e) => ({
                  label: e.currency_code,
                  value: e.currency_code,
                  front: e.image,
                }))}
                onChange={(e, i) => {
                  this.setState({
                    currency: e,
                    customer_id: e ? customer_id : "",
                    bank_code: e ? bank_code : "",
                    bank_account_number: e ? bank_account_number : "",
                    bank_account_name_th: e ? bank_account_name_th : "",
                    bank_account_name_en: e ? bank_account_name_en : "",
                  },()=>{this.GetCustomer()});
                }}
                value={currency}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2 pr-label">Customer{required}</div>
              <Select
                className="form-control pr-input"
                placeholder="Customer..."
                options={data_customer
                  ?.filter((e) => e.broker === broker_id)
                  .filter((e) => e.currency === currency)}
                onChange={(e, i) => {
                  this.setState({
                    customer_id: e,
                    bank_code: e ? i.bank_code : "",
                    bank_account_name_th: e ? i.bank_account_name_th : "",
                    bank_account_name_en: e ? i.bank_account_name_en : "",
                    bank_account_number: e ? i.bank_account_number : "",
                  });
                }}
                value={customer_id}
                disabled={!broker_id}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-150 mt-2 pr-label">Ref no{required}</div>
              <input
                type="text"
                className="form-control pr-input"
                placeholder="Ref no..."
                maxLength={100}
                onChange={(e) => {
                  this.setState({ ref_no: e.target.value });
                }}
                value={ref_no}
              />
              <button
                className="btn btn-dark ms-2 px-3 text-nowrap"
                onClick={() => {
                  this.setState({ ref_no: new Date().getTime().toString() });
                }}
              >
                Generate
              </button>
            </div>
            <div className="d-flex mb-3 position-relative">
              <div className="wpx-150 mt-2 pr-label">Amount{required}</div>
              <NumericFormat
                thousandSeparator=","
                decimalScale={2}
                type="text"
                className="form-control pr-input pe-5"
                placeholder="Amount..."
                value={amount}
                onValueChange={(values) => {
                  this.setState({ amount: values.value });
                }}
              />
              <span
                className="text-secondary position-absolute"
                style={{ right: 12, top: 6 }}
              >
                {currency || "THB"}
              </span>
            </div>
            {broker_id && (
              <div>
                <div className="pu-section-title mt-4">
                  <span className="icon">{"\uf19c"}</span>Bank Information
                </div>
                <div className="d-flex mb-2">
                  <div className="wpx-150 mt-2 pr-label">Bank Name{required}</div>
                  <Select
                    className="form-control"
                    placeholder="Bank Name..."
                    options={data_bank}
                    onChange={(e) => {
                      this.setState({ bank_code: e });
                    }}
                    value={bank_code}
                    disabled={customer_id}
                  ></Select>
                </div>
                <div className="d-flex mb-2">
                  <div className="wpx-150 mt-2 pr-label">Account Number{required}</div>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="Account Number..."
                    maxLength={20}
                    onChange={(e) => {
                      if (!float(e.target.value)) return;
                      this.setState({ bank_account_number: e.target.value });
                    }}
                    value={bank_account_number}
                    disabled={customer_id}
                  />
                </div>
                <div className="d-flex mb-2">
                  <div className="wpx-150 mt-2 pr-label">Account NameTH{required}</div>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="Account NameTH..."
                    onChange={(e) => {
                      this.setState({ bank_account_name_th: e.target.value });
                    }}
                    value={bank_account_name_th}
                    disabled={customer_id}
                  />
                </div>
                <div className="d-flex mb-2">
                  <div className="wpx-150 mt-2 pr-label">Account NameEN{required}</div>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="Account NameEN..."
                    onChange={(e) => {
                      this.setState({ bank_account_name_en: e.target.value });
                    }}
                    value={bank_account_name_en}
                    disabled={customer_id}
                  />
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className={`btn btn-dark px-5 me-1 rounded-pill ${params("type")}.create`}
              onClick={() => {
                this.Create();
              }}
            >
              submit
            </button>
            <button
              className="btn btn-outline-dark px-5 ms-1 rounded-pill"
              onClick={() => {
                this.setState({ modal_create: false });
              }}
            >
              cancel
            </button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={modal_detail}
          size="lg"
          dialogClassName="pr-modal pr-scope pu-scope"
          onHide={() => this.setState({ modal_detail: false })}
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Transaction detail</div>
              <h5 className="fw-bold mb-0">Detail Transaction</h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="pu-section mb-0">
            <div className="pu-kv">
              <span className="pu-kv-label">Status</span>
              <span className="pu-kv-value">{StatusTnx(status)}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Ref No.</span>
              <span className="pu-kv-value">{ref_no}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Time</span>
              <span className="pu-kv-value">{format_date(created_at, "dd/mm/yyyy hh:mm:ss", "en")}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Type</span>
              <span className="pu-kv-value">{type}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Customer</span>
              <span className="pu-kv-value">{customer?.name_en || "-"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Customer Email</span>
              <span className="pu-kv-value">{customer?.email || "-"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Fee Rate Type</span>
              <span className="pu-kv-value">{fee_type}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Fee Rate</span>
              <span className="pu-kv-value">{toFixed(fee_rate, 2)}{" "}
                {fee_type === "percentage" ? "%" : currency || "THB"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Amount</span>
              <span className="pu-kv-value">{toFixed(amount, 2)} {currency || "THB"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Fee</span>
              <span className="pu-kv-value">{toFixed(fee, 2)} {currency || "THB"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">VAT Type</span>
              <span className="pu-kv-value">{is_vat ? "VAT" : "NO VAT"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">VAT</span>
              <span className="pu-kv-value">{toFixed(vat, 2)} {currency || "THB"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Amount Net</span>
              <span className="pu-kv-value">{toFixed(amount_net, 2)} {currency || "THB"}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Remark</span>
              <span className="pu-kv-value">{remark}</span>
            </div>
            <div className="pu-kv">
              <span className="pu-kv-label">Status Remark</span>
              <span className="pu-kv-value">{status_reason}</span>
            </div>
            {profile?.user_type === "super_user" && (
              <div className="pu-kv">
                <span className="pu-kv-label">Url Payment</span>
                <span className="pu-kv-value">
                  <a
                    href={`${window.location.origin}/qr-source-link?i=${uid}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {window.location.origin}/qr-source-link?i={uid}
                  </a>
                </span>
              </div>
            )}
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-outline-dark px-5 rounded-pill"
              onClick={() => {
                this.setState({ modal_detail: false });
              }}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
